/**
 * お問い合わせページ（公開）
 * HubSpot フォーム埋め込み
 */
import { useEffect } from "react";
import { PublicHeader, PublicFooter } from "./LandingPage.js";

const PRIMARY = "#534AB7";

export default function ContactPage() {
  useEffect(() => {
    // HubSpot embed script を動的にロード
    const script = document.createElement("script");
    script.src = "//js-na2.hsforms.net/forms/embed/v2.js";
    script.charset = "utf-8";
    script.type = "text/javascript";
    script.onload = () => {
      (window as any).hbspt?.forms?.create({
        portalId: "21050458",
        formId: "77603545-78ab-416a-85f7-f893c7ce1f15",
        region: "na2",
        target: "#contact-form-container",
      });
    };
    document.body.appendChild(script);
    return () => {
      // クリーンアップ: スクリプトが残っていると複数回埋め込みされるので削除
      if (document.body.contains(script)) document.body.removeChild(script);
    };
  }, []);

  return (
    <div style={{ fontFamily: "system-ui, -apple-system, sans-serif", color: "#1a1a1a", background: "white" }}>
      <PublicHeader minimal />

      <section style={{ background: "linear-gradient(135deg, #534AB7 0%, #7F77DD 100%)", color: "white", padding: "60px 24px 50px", textAlign: "center" }}>
        <h1 style={{ fontSize: 36, fontWeight: 800, marginBottom: 12 }}>お問い合わせ</h1>
        <p style={{ fontSize: 16, opacity: 0.95 }}>
          サービスに関するご質問・資料請求・お見積りなど、お気軽にご相談ください。
        </p>
      </section>

      <section style={{ padding: "60px 24px", background: "#faf9f7" }}>
        <div style={{ maxWidth: 900, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1.5fr", gap: 40, alignItems: "start" }} className="contact-grid">
          {/* 左カラム: 相談例・営業時間 */}
          <div>
            <div style={{ background: "white", borderRadius: 12, padding: "28px 24px", marginBottom: 20 }}>
              <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 14, color: PRIMARY }}>お問い合わせ内容の例</div>
              <ul style={{ margin: 0, paddingLeft: 20, fontSize: 14, color: "#4a4a48", lineHeight: 2 }}>
                <li>機能・仕様に関するご質問</li>
                <li>HubSpot / クラウドサイン 連携の技術的な確認</li>
                <li>操作方法やトラブルのご相談</li>
                <li>その他フィードバック</li>
              </ul>
            </div>

            <div style={{ background: "#EEEDFE", borderRadius: 12, padding: "20px 22px", fontSize: 13, color: PRIMARY, lineHeight: 1.8 }}>
              <strong>営業時間</strong>
              <br />
              平日 10:00 〜 18:00（土日祝除く）
              <br />
              通常 1 〜 2 営業日以内にご返信いたします。
            </div>
          </div>

          {/* 右カラム: HubSpot フォーム */}
          <div>
            <div style={{ background: "white", borderRadius: 12, padding: "32px 32px" }}>
              <div id="contact-form-container" style={{ minWidth: 320, overflow: "visible" }} />
              <noscript>
                <div style={{ padding: "24px 0", color: "#6b6b68", fontSize: 14 }}>
                  お問い合わせフォームを表示するには JavaScript を有効にしてください。
                </div>
              </noscript>
            </div>
          </div>
        </div>
      </section>

      <PublicFooter minimal />

      {/* レスポンシブ: モバイルで 1 カラム */}
      <style>{`
        @media (max-width: 768px) {
          .contact-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
}
